export default __webpack_public_path__ + "static/media/coresanscr85-webfont.3d68020e.woff2";